<template>
    <div>
        <el-row type="flex" justify="end">
            <el-col :span="24">
                <el-button-group>
                    <el-button @click="addProduct()">
                        Agregar adicionales
                    </el-button>
                </el-button-group>
            </el-col>
        </el-row>
        <br>
        <div v-loading="loading"></div>

        <div class="el-table__header-wrapper el-table__body-wrapper is-scroll-left">
            <table border="1" class="el-table__header custom-lock" style="width: 100%; word-break: break-word"
                   v-if="showTable">
                <thead class="is-group has-gutter"
                       style="background: rgb(191,191,191) !important; font-weight: bold !important;">
                <tr>
                    <th colspan="9" style="text-align: center !important; font-weight: bold !important;">
                        Cuadro comparativo desglosado de las cotizaciones
                    </th>
                </tr>
                <tr>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        Conceptos a cotizar
                    </th>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        Cantidad
                    </th>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        {{requestForm.providers[0].name ? requestForm.providers[0].name : ''}}<br>
                        (costo unitario)
                    </th>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        {{requestForm.providers[1].name ? requestForm.providers[1].name : ''}}<br>
                        (costo unitario)
                    </th>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        {{requestForm.providers[2].name ? requestForm.providers[2].name : ''}}<br>
                        (costo unitario)
                    </th>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        Búsqueda en <br>
                        compranet
                    </th>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        Costo de referencia <br>
                        por Adquisición
                    </th>
                    <th style="text-align: center !important; font-weight: bold !important;">
                        Media de las <br>
                        cotizaciones
                    </th>
                    <td style="text-align: center !important; font-weight: bold !important;">
                       Acciones
                    </td>
                </tr>
                </thead>
                <tbody class="el-table__body">
                    <tr v-for="(article, key) in arrayArticles" v-if="!article.isHidden">
                        <td style="text-align: center !important;" height="20">
                            {{setName(article)}}
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            {{article.amount ? article.amount : 0}}
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="article.costProv1"
                                         :precision="2">
                            </vue-numeric>
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="!requestForm.providers[1].name"
                                         v-model="article.costProv2"
                                         :precision="2">
                            </vue-numeric>
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="!requestForm.providers[2].name"
                                         v-model="article.costProv3"
                                         :precision="2">
                            </vue-numeric>
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="!requestForm.compranetSearch"
                                         v-model="article.searchCompranet"
                                         :precision="2">
                            </vue-numeric>
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="article.reference"
                                         :precision="2">
                            </vue-numeric>
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            {{setArticleMean(article,key) | currency('$')}}
                        </td>
                        <td style="text-align: center !important; padding: 5px">
                            <el-tooltip class="item" effect="dark" content="Eliminar" placement="top-end">
                                <el-button disabled type="danger" size="mini" icon="fas fa-trash"/>
                            </el-tooltip>
                        </td>
                    </tr>
                    <tr v-for="(article, key2) in arrayArticles" v-if="article.isHidden">
                        <td style="text-align: center !important;" height="20">
                            <br>
                            <br v-if="!(article.article_id == 7 || article.article_id == 23
                                      || article.article_id == 32 || article.article_id == 36
                                      || article.article_id == 40 || article.article_id == 45 || article.article_id == 54 )">
                            <br v-if="!(article.article_id == 7 || article.article_id == 23
                                      || article.article_id == 32 || article.article_id == 36
                                      || article.article_id == 40 || article.article_id == 45 || article.article_id == 54 )">
                            <el-select
                                    style="width:90%"
                                    v-model="article.article_id"
                                    filterable
                                    :disabled="onlyRead== true ? true: false"
                                    placeholder="Seleccionar">
                                <el-option
                                        v-for="(item,key5) in catalogs.catProductsOrServicesArticles"
                                        :key="(key2+1)+'_'+(key5+1)+'_article'"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <br>
                            <br>
                            <el-input v-model="article.describeAnotherName"
                                      type="textarea"
                                      v-if="article.article_id == 7 || article.article_id == 23
                                      || article.article_id == 32 || article.article_id == 36
                                      || article.article_id == 40 || article.article_id == 45 || article.article_id == 54 "
                                      style="word-break: break-word; width: 90%"
                                      resize="none"
                                      :disabled="onlyRead== true ? true: false"
                                      :autosize="{ minRows: 3, maxRows: 4}"
                                      placeholder="Describir Otro">
                            </el-input>
                            <br>
                            <br>
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            <br>
                            <el-input-number v-model="article.amount"
                                             :precision="0"
                                             style="width: 90%"
                                             :step="1"
                                             :min="0"
                                             :disabled="onlyRead== true ? true: false"
                                             placeholder="Cantidad">
                            </el-input-number>
                            <br>
                            <br>
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            $0.00
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            $0.00
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            $0.00
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            $0.00
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            $0.00
                        </td>
                        <td style="text-align: center !important; padding: 5px" height="100">
                            {{setArticleMean(article,key2)}}
                        </td>
                        <td style="text-align: center !important; padding: 5px">
                            <el-tooltip class="item" effect="dark" content="Eliminar" placement="top-end">
                                <el-button  :disabled="onlyRead== true ? true: false" @click="deleteProduct(article)" type="danger" size="mini" icon="fas fa-trash"/>
                            </el-tooltip>
                        </td>
                    </tr>

                    <tr style="text-align: center !important;" height="20">
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                            Total del Contrato
                          <br>
                          <el-tooltip placement="top">
                            <div slot="content">Suma del costo mensual de los componentes</div>
                            <i style="font-size: 10px" class="fas fa-info"/>
                          </el-tooltip>
                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                           N/A
                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="onlyRead== true ? true: false"
                                         v-model="arrayArticles[0].totalProv1"
                                         :precision="2">
                            </vue-numeric>
                          <el-tooltip placement="top">
                            <div slot="content">La cifra resultante sale a partir de la multiplicación de la cantidad por el costo unitario por cada concepto que se coloca.
                              <br>
                              Posteriormente se suman los totales resultantes de cada concepto, lo que equivale al total mensual.</div>
                            <i style="font-size: 10px" class="fas fa-info"/>
                          </el-tooltip>

                         <!--   {{ setTotals(arrayArticles,2) * (requestForm.providers[0].monthlyAgreementValidity?
                            requestForm.providers[0].monthlyAgreementValidity : 0)}}-->
                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="onlyRead== true ? true: false"
                                         v-model="arrayArticles[0].totalProv2"
                                         :precision="2">
                            </vue-numeric>
                            <!--{{ setTotals(arrayArticles,3) * (requestForm.providers[1].monthlyAgreementValidity?
                            requestForm.providers[1].monthlyAgreementValidity : 0)}}-->

                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="onlyRead== true ? true: false"
                                         v-model="arrayArticles[0].totalProv3"
                                         :precision="2">
                            </vue-numeric>
                           <!-- {{ setTotals(arrayArticles,4) * (requestForm.providers[2].monthlyAgreementValidity?
                            requestForm.providers[2].monthlyAgreementValidity : 0)}}-->
                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="!requestForm.compranetSearch"
                                         v-model="arrayArticles[0].totalSearchCompranet"
                                         :precision="2">
                            </vue-numeric>
                            <!--{{ setTotals(arrayArticles,5) * (requestForm.providers[3].monthlyAgreementValidity?
                            requestForm.providers[3].monthlyAgreementValidity : 0)}}-->
                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                           N/A
                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         :disabled="onlyRead== true ? true: false"
                                         v-model="arrayArticles[0].totalMean"
                                         :precision="2">
                            </vue-numeric>
                           <!-- {{getTotalMeanContract()}}-->
                        </td>
                        <td style="font-weight: bold !important; background: rgb(191,191,191)">
                            N/A
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from "vuex";


    export default {

        props: {
            articles: {
                type: Array,
                required: true
            }
        },

        computed: {
            ...mapGetters("form", {
                requestForm: "requestForm",
                catalogs: "catalogs",
                general: "general",
                onlyRead: "onlyRead",
                optionEditor: "optionEditor"
            }),
            ...mapGetters(["userInfo"]),
            difficultLifeTypeAndHealthWeek() {
                return this.userInfo && this.userInfo.office && this.userInfo.office.isHardLife == 1 ? true : false;
            },
            arrayArticles() {
                return this.articlesAux = Object.assign([], this.articles);
            }

        },

        data() {
            return {
                showTable: true,
                articlesAux: [],
                loading: false
            }
        },
        methods: {
            setName(props) {
                if (props && props.article && props.article.name) {
                    return props.article.name
                }
            },

            setTotals(articles, type, key) {
                if (articles && articles.length > 0) {
                    let _res = null;
                    if (type == 1) {
                        _res = articles.map(o => o.amount);
                        this.arrayArticles[0].totalAmount = _res != null ? parseFloat(_res.reduce((a, b) => a + b, 0)) : 0;

                    } else if (type == 2) {
                        _res = articles.map(o => o.costProv1 * o.amount);
                        if(this.requestForm.providers[0].name != null || this.requestForm.providers[0].name != ''){
                            this.arrayArticles[0].totalProv1 = _res != null ? _res.reduce((a, b) => a + b, 0) : 0;
                        }else{
                            this.arrayArticles[0].costProv1 = null
                        }


                    } else if (type == 3) {
                        _res = articles.map(o => o.costProv2 * o.amount);
                        this.arrayArticles[0].totalProv2 = _res != null ? _res.reduce((a, b) => a + b, 0) : 0;

                    } else if (type == 4) {
                        _res = articles.map(o => o.costProv3 * o.amount);
                        this.arrayArticles[0].totalProv3 = _res != null ? _res.reduce((a, b) => a + b, 0) : 0;

                    } else if (type == 5) {
                        _res = articles.map(o => o.searchCompranet);
                        this.arrayArticles[0].totalSearchCompranet = _res != null ? _res.reduce((a, b) => a + b, 0) : 0;

                    } else if (type == 6) {
                        _res = articles.map(o => o.mean);
                        this.arrayArticles[0].totalMean = _res != null ? _res.reduce((a, b) => a + b, 0) : 0;

                    }else if (type == 7) {
                        _res = articles.map(o => o.reference);

                        this.arrayArticles[0].totalReference = _res != null ? _res.reduce((a, b) => a + b, 0) : 0;

                    }
                     _res = _res != null ? _res.reduce((a, b) => a + b, 0) : 0;

                    return _res > 0 && type == 1 ? _res.toFixed(0) : _res.toFixed(2)
                }

            },

            setArticleMean(article, key) {
                if (article) {
                    let _prov1 = parseFloat(article.costProv1);
                    let _prov2 = parseFloat(article.costProv2);
                    let _prov3 = parseFloat(article.costProv3);
                    let _prov4 = parseFloat(article.searchCompranet);
                    let _res = 0;

                    if (_prov1 > 0 && _prov2 > 0 && _prov3 > 0 && _prov4 > 0) {
                        _res = (_prov1 + _prov2 + _prov3 + _prov4) / 4;

                    }else{
                        if(_prov4 > 0){
                            if (_prov1 > 0 && _prov2 > 0) {
                                _res = (_prov1 + _prov2 + _prov4) / 3;
                            } else {
                                _res = (_prov1 + _prov4) / 2;
                            }
                        }else{
                            if (_prov1 > 0 && _prov2 > 0 && _prov3 > 0) {
                                _res = (_prov1 + _prov2 + _prov3) / 3;
                            }
                            else if (_prov1 > 0 && _prov2 > 0) {
                                _res = (_prov1 + _prov2) / 2;

                            }
                            else if (_prov1 > 0) {
                                _res = _prov1
                            }
                        }
                    }
                    try {
                        this.requestForm.articles[key].mean = _res;
                        return _res.toFixed(2)
                    } catch (err) {
                        return _res;
                    }


                }

            },

            addProduct() {
                this.showTable = false;
                this.loading = true;
                this.arrayArticles.push({
                    "id": null,
                    "article_id": 7,
                    "amount": 0,
                    "describeAnotherName": null,
                    "particularDescription": null,
                    "technicalDescription": null,
                    "searchCompranet": null,
                    "mean": 0,
                    "costProv1": 0,
                    "costProv2": 0,
                    "costProv3": 0,
                    "totalAmount": 0,
                    "totalProv1": 0,
                    "totalProv2": 0,
                    "totalProv3": 0,
                    "totalSearchCompranet": 0,
                    "reference": 0,
                    "totalMean": 0,
                    "isHidden": true,
                });
                setTimeout(() => {
                    this.showTable = true;
                    this.loading = false;
                    this.requestForm.articles = this.arrayArticles
                }, 500);

            },

            filterArticle(data, cat_acquisition_type_id, product_or_service_id) {
                if (!data || !cat_acquisition_type_id) return [];
                /*if (cat_acquisition_type_id == 2 || cat_acquisition_type_id == 4) {
                    return data;
                }
                if (!product_or_service_id) return [];
                return data = data.filter((item) => product_or_service_id == item.id);*/
                return data;

            },

            deleteProduct(article) {
                this.$confirm('¿Eliminar elemento?').then(confirm => {
                    this.showTable = false;
                    this.loading = true;
                    let index =  this.arrayArticles.indexOf(article);
                    this.arrayArticles.splice(index,1);
                    setTimeout(() => {
                        this.showTable = true;
                        this.loading = false;
                        this.requestForm.articles = this.arrayArticles
                    },500);


                }).catch(e => {

                });
            },

            getTotalMonthly(){
               let _monthly = this.requestForm.providers.map(up => up.monthlyAgreementValidity);
               return _monthly = _monthly != null ? _monthly.reduce((a, b) => a + b, 0) : 0;
            },

            getTotalMeanContract(){
                if(this.requestForm.articles && this.requestForm.articles.length > 0){
                    let _a = this.setTotals(this.arrayArticles,2);
                    let _a1 = this.requestForm.providers[0].monthlyAgreementValidity;
                    let _b = this.setTotals(this.arrayArticles,3);
                    let _b1 = this.requestForm.providers[1].monthlyAgreementValidity;
                    let _c = this.setTotals(this.arrayArticles,4);
                    let _c1 = this.requestForm.providers[2].monthlyAgreementValidity;
                    let _d = this.setTotals(this.arrayArticles,5);
                    let _d1 = this.requestForm.providers[3].monthlyAgreementValidity;
                    let _res = 0;
                    _res = ((_a*_a1) + (_b*_b1) + (_c*_c1) + (_d *_d1));
                    this.requestForm.articles[0].totalContract = _res >= 0 ? _res : null;
                    return _res
                }



            }
        },
    }
</script>

<style>

    .el-table-custom {
        background: rgb(191, 191, 191) !important;
        color: #612323 !important;
    }

</style>